import http from "../http-common";

class YearTermTypeService {
  createYear_Term_Types(data) {
    return http.post(`/api/year_term_type`, data);
  }
  getYear_Term_Types() {
    return http.get(`/api/year_term_type`);
  }
  getYear_Term_Type(id) {
    return http.get(`/api/year_term_type/` + id);
  }
  updateYear_Term_Type(id, data) {
    return http.put(`/api/year_term_type/${id}`, data);
  }
  getYear_Term_TypeByFilter(data) {
    return http.get(`/api/year_term_type/findOneByYearTermType?year=`+data.year+'&&term='+data.term+'&&exam_type='+data.exam_type);
  }
}

export default new YearTermTypeService();